export const filtersRolDefault = (rol, filtrosIniciales) => {
  let defaultFilterValues = { ...filtrosIniciales };

  switch (rol) {
    case "ADMIN":
      defaultFilterValues = {
        ...defaultFilterValues,
        visitasRecientes: true,
      };
      break;

    case "TECH":
      defaultFilterValues = {
        ...defaultFilterValues,
        visitasRecientes: false,
        // ocultarImpagados: true,
      };
      break;
    case "TECH_COOR":
      defaultFilterValues = {
        ...defaultFilterValues,
        visitasRecientes: false,
        // ocultarImpagados: true,
      };
      break;

    // case "AAFF":
    //   defaultFilterValues = {
    //     ...defaultFilterValues,
    //     ano: new Date().getFullYear(),
    //   };
    //   break;

    default:
      break;
  }
  return defaultFilterValues;
};
